import PropTypes from 'prop-types';

export const pointType = PropTypes.shape({ refDate: PropTypes.string.isRequired, latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired, segment: PropTypes.number.isRequired });
